export default (projectUsers) => {
	if (!Array.isArray(projectUsers)) return [];
	return projectUsers.filter(({isProjectOwner}) => isProjectOwner);
};
